import {
  Col,
  Row,
  Typography,
  Image,
  Card,
  Button,
  Divider,
  Grid,
  Tag,
} from "antd";
import React, { useState, useEffect } from "react";
import config from "../../utils/Config";
import Parser from "html-react-parser";
import { useKeycloak } from "@react-keycloak/web";
import Page from "../../Components/Page/Page";
import { FaqsService } from "../../Service/FaqsService";
import { Link } from "react-router-dom";
import { handleLogError, ErrorPage } from "../../Helpers/Helpers";
import { useNavigate } from "react-router-dom";
import { useTranslate } from "../../Translate";
import languages from "../../utils/languages";
import AdminFooter from "../../Components/Footer/AdminFooter";
import { TfiArrowRight } from "react-icons/tfi";
import styles from "./Home.module.less";
const { useBreakpoint } = Grid;
const { Title, Paragraph } = Typography;
const imageFallback =
  "data:image/png;base64,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";

function getMax(arr, prop) {
  var max;
  for (var i = 0; i < arr.length; i++) {
    if (max == null || parseInt(arr[i][prop]) > parseInt(max[prop]))
      max = arr[i];
  }
  return max;
}

function textEllipsis(str, maxLength, { side = "end", ellipsis = "..." } = {}) {
  if (str.length > maxLength) {
    switch (side) {
      case "start":
        return ellipsis + str.slice(-(maxLength - ellipsis.length));
      case "end":
      default:
        return str.slice(0, maxLength - ellipsis.length) + ellipsis;
    }
  }
  return str;
}

const Home = () => {
  const screens = useBreakpoint();
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(false);
  const { keycloak } = useKeycloak();
  const i18n = useTranslate();
  const { t, getCurrentLanguage } = i18n;
  const navigate = useNavigate();
  const handleClickRead = () => {
    navigate("/news");
  };

  const handleAccedi = () => {
    keycloak.login();
  };
  const getData = async () => {
    try {
      let languageid = languages.filter(
        (element) => element.name === getCurrentLanguage()
      )[0].id;
      var token = keycloak.token !== undefined ? keycloak.token : null;
      var accounts =
        keycloak.tokenParsed !== undefined
          ? keycloak.tokenParsed.accounts.toString()
          : null;
      var userid =
        keycloak.tokenParsed !== undefined
          ? keycloak.tokenParsed.sub.toString()
          : null;
      let data = {};
      data["languageid"] = languageid;
      const response = await FaqsService.getNews(token, accounts, userid, data);
      var news_last = getMax(response.data, "id");
      setNews(news_last);
      ErrorPage(response.status, navigate);
    } catch (error) {
      handleLogError(error);
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, []);
  return (
    <>
      {/* Current break point:{' '}
    {Object.entries(screens)
      .filter((screen) => !!screen[1])
      .map((screen) => (
        <Tag color="blue" key={screen[0]}>
          {screen[0]}
        </Tag>
      ))} */}

      <Row middle="center" justify="center">
        <Col span={18} style={{ border: "0px solid" }}>
          <Title className={styles.hometitle}>
            Benvenuto in Toshiba HUB, il portale dei servizi in Cloud di
            Toshiba.
          </Title>
          <Page loading={loading}>
            <Row>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={24}
                xxl={15}
                className={styles.imageGirl}
              >
                <Row>
                  <Col xs={0} sm={0} md={0} lg={12} xl={12} xxl={12}></Col>
                  <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                    <Row>
                      <Col
                        span={24}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <img alt="hub" title="hub" src={config.hub} />
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        span={24}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <p className={styles.homehubtxt}>
                          Toshiba HUB mette a tua disposizione uno store dove
                          acquistare servizi innovativi in Cloud.{" "}
                          <Link to="/store" title="Store">
                            <b>Vai allo store &raquo;</b>
                          </Link>
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        span={24}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <p className={styles.homehubtxt}>
                          Per acquistare i servizi dallo Store è necessario
                          essere registrati.
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        span={24}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <p className={styles.homehubtxt}>
                          Non hai ancora un account?<br></br>
                          <Link to="/registration" title="Registrati">
                            <b>Registrati &raquo;</b>
                          </Link>
                        </p>
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        span={24}
                        style={{ textAlign: "center", padding: "20px" }}
                      >
                        <p className={styles.homehubtxt}>
                          Sei già registrato?&nbsp;&nbsp;
                          <Button
                            type="primary"
                            htmlType="submit"
                            className={styles.homebtn}
                            onClick={handleAccedi}
                          >
                            Accedi
                          </Button>
                        </p>
                        {/* <Divider
                          orientationMargin="0"
                          className={styles.homedivider}
                        /> */}
                        <div className={styles.homedivider}></div>
                      </Col>
                    </Row>
                    <Row middle="center" justify="center">
                      <Col style={{ textAlign: "center" }}>
                        <Row>
                          <Col
                            span={24}
                            style={{ border: "0px solid", textAlign: "center" }}
                          >
                            <img
                              alt="support"
                              title="support"
                              style={{ float: "left" }}
                              src={config.support}
                            />

                            <span className={styles.homehubtxt2}>
                              Hai bisogno di supporto? Scrivi a:<br></br>
                              <Link
                                to="#"
                                onClick={(e) => {
                                  window.location.href =
                                    "mailto:supporto-hub@toshibatec-tiis.com";
                                  e.preventDefault();
                                }}
                              >
                                supporto-hub@toshibatec-tiis.com
                              </Link>
                            </span>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              <Col
                xs={24}
                sm={24}
                md={24}
                lg={24}
                xl={{ span: 24, offset: 0 }}
                xxl={9}
                style={{
                  border: "0px solid",
                  background: "white",
                  padding: "20px",
                }}
              >
                <Row middle="center" justify="center">
                  <Card
                    // hoverable
                    style={{ width: 400 }}
                    cover={
                      <Image
                        preview={false}
                        // width={400}
                        // height={140}
                        src={news.logo != null ? news.logo : "error"}
                        fallback={imageFallback}
                        style={{
                          border: "0px solid white",
                          borderRadius: "0px",
                        }}
                      />
                    }
                  >
                    <Row style={{ border: "0px solid", minHeight: "300px" }}>
                      <Col span={24}>
                        <Title
                          level={4}
                          style={{ color: "#496c7f", textAlign: "left" }}
                        >
                          {news.titolo}
                        </Title>
                        <br></br>
                        <p style={{ textAlign: "left" }}>
                          {news.dataattivazione != null
                            ? "" +
                              new Intl.DateTimeFormat("it-IT", {
                                year: "numeric",
                                month: "2-digit",
                                day: "2-digit",
                              }).format(new Date(news.dataattivazione))
                            : ""}
                        </p>
                        <Paragraph>
                          {news.testo !== undefined
                            ? Parser(textEllipsis(news.testo, 500))
                            : ""}
                        </Paragraph>
                        <br></br>
                        <Row>
                          <Col span={21}>
                            <p
                              style={{
                                textAlign: "right",
                                color: "#496c7f",
                                fontSize: "14px",
                                paddingTop: "5px",
                              }}
                            >
                              Leggi le news&nbsp;&nbsp;&nbsp;
                            </p>
                          </Col>
                          <Col span={3}>
                            <TfiArrowRight
                              title="news"
                              onClick={handleClickRead}
                              style={{
                                fontSize: "32px",
                                textAlign: "right",
                                cursor: "pointer",
                                color: "#496c7f",
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </Card>
                </Row>
              </Col>
            </Row>
          </Page>
        </Col>
      </Row>
      <Row middle="center" justify="center">
        <Col>
          <AdminFooter />{" "}
        </Col>
      </Row>
    </>
  );
};

export default Home;
